import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';



/**
 *商品情報を削除するクラス
 *
 * @export DeleteGoodsService
 * @class DeleteGoodsService
 * @extends {PlessResponder}
 */
@Injectable()
export class DeleteGoodsService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private pCode: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof DeleteGoodsService
   */
  execute(model: KYMW1100Model, pCode: string, successFunc: Function = null): void {
    this.model = model;
    this.pCode = pCode;
    this.successFunc = successFunc;
    this.send('deleteGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteGoodsService
   */
  success(data: any): void {
    // 表記表示を行う。
    this.model.kymw1100Component.setWindowVisible('NEW');
    // 「eBASEデータ」ボタンの活性制御を行う。
    this.model.kymw1100Component.setWindowVisible('EBASE');
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
